<!-- Trip Changes (V2) -->
<h3>Trip Changes</h3>
<sd-portal-audit-detail-list-v2
  [loading]="tripLogsLoading"
  [loaded]="tripLogsLoaded"
  [audits]="tripLogs"
  [hasMore]="tripLogsHasMore"
  (nextPage)="onTripLogsNextPage.emit(tripId)"
  noAuditsMessage="No audit records for this trip"
></sd-portal-audit-detail-list-v2>

<!-- Trip Legs (V2) -->
<h3 style="margin-top: 24px;">Legs</h3>
<div *ngIf="tripLegsLoading">Loading legs...</div>
<div *ngIf="tripLegsLoaded">
  <div *ngIf="tripLegs && tripLegs.length > 0; else noTripLegs">
    <mat-accordion class="leg-container">
      <mat-expansion-panel *ngFor="let leg of tripLegs"
        (opened)="leg.eventId ? legEventLogsOpened.emit(leg.eventId) : null"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            Leg {{ leg.legNumber }}<span *ngIf="leg.departureAirport && leg.arrivalAirport">, {{ leg.departureAirport }} ⟹ {{ leg.arrivalAirport }}</span><span *ngIf="leg.departureTime && leg.arrivalTime">, {{ leg.departureTime | momentDate : 'M/D/YYYY HH:mm' : true }} UTC - {{ leg.arrivalTime | momentDate : 'M/D/YYYY HH:mm' : true }} UTC</span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <div style="padding: 16px;">
            <mat-accordion class="nested-accordion">
              <!-- Crew Members -->
              <mat-expansion-panel
                class="nested-panel"
                (opened)="flightCrewMembersOpened.emit(leg.flightId)"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>Crew Members</mat-panel-title>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                  <div *ngIf="flightCrewMembersLoading">Loading...</div>
                  <div *ngIf="flightCrewMembersLoaded">
                    <div *ngIf="!flightCrewMembers || flightCrewMembers.length === 0">
                      No crew members found
                    </div>
                    <mat-accordion *ngIf="flightCrewMembers && flightCrewMembers.length > 0">
                      <mat-expansion-panel
                        *ngFor="let crew of flightCrewMembers"
                        class="nested-panel"
                        (opened)="crewLogsOpened.emit(crew.crewId)"
                      >
                        <mat-expansion-panel-header>
                          <mat-panel-title>{{ crew.firstName }} {{ crew.lastName }}</mat-panel-title>
                        </mat-expansion-panel-header>
                        <ng-template matExpansionPanelContent>
                          <!-- Crew member logs -->
                          <sd-portal-audit-detail-list-v2
                            [loading]="crewLogsLoading"
                            [loaded]="crewLogsLoaded"
                            [audits]="crewLogs"
                            [hasMore]="crewLogsHasMore"
                            (nextPage)="crewLogsNextPage.emit(crew.crewId)"
                            noAuditsMessage="No audit records for crew member"
                          ></sd-portal-audit-detail-list-v2>

                          <!-- Catering (Departure) -->
                          <mat-accordion *ngIf="crew.departureCateringId">
                            <mat-expansion-panel
                              class="nested-panel"
                              (opened)="crewCateringLogsOpened.emit(crew.departureCateringId)"
                            >
                              <mat-expansion-panel-header>
                                <mat-panel-title>Catering (Departure)</mat-panel-title>
                              </mat-expansion-panel-header>
                              <ng-template matExpansionPanelContent>
                                <sd-portal-audit-detail-list-v2
                                  [loading]="crewCateringLogsLoading"
                                  [loaded]="crewCateringLogsLoaded"
                                  [audits]="crewCateringLogs"
                                  [hasMore]="crewCateringLogsHasMore"
                                  (nextPage)="crewCateringLogsNextPage.emit(crew.departureCateringId)"
                                  noAuditsMessage="No audit records for catering"
                                ></sd-portal-audit-detail-list-v2>
                              </ng-template>
                            </mat-expansion-panel>
                          </mat-accordion>

                          <!-- Hotel (Departure) -->
                          <mat-accordion *ngIf="crew.departureHotelId">
                            <mat-expansion-panel
                              class="nested-panel"
                              (opened)="crewHotelLogsOpened.emit(crew.departureHotelId)"
                            >
                              <mat-expansion-panel-header>
                                <mat-panel-title>Hotel (Departure)</mat-panel-title>
                              </mat-expansion-panel-header>
                              <ng-template matExpansionPanelContent>
                                <sd-portal-audit-detail-list-v2
                                  [loading]="crewHotelLogsLoading"
                                  [loaded]="crewHotelLogsLoaded"
                                  [audits]="crewHotelLogs"
                                  [hasMore]="crewHotelLogsHasMore"
                                  (nextPage)="crewHotelLogsNextPage.emit(crew.departureHotelId)"
                                  noAuditsMessage="No audit records for hotel"
                                ></sd-portal-audit-detail-list-v2>
                              </ng-template>
                            </mat-expansion-panel>
                          </mat-accordion>

                          <!-- Hotel (Arrival) -->
                          <mat-accordion *ngIf="crew.arrivalHotelId">
                            <mat-expansion-panel
                              class="nested-panel"
                              (opened)="crewHotelLogsOpened.emit(crew.arrivalHotelId)"
                            >
                              <mat-expansion-panel-header>
                                <mat-panel-title>Hotel (Arrival)</mat-panel-title>
                              </mat-expansion-panel-header>
                              <ng-template matExpansionPanelContent>
                                <sd-portal-audit-detail-list-v2
                                  [loading]="crewHotelLogsLoading"
                                  [loaded]="crewHotelLogsLoaded"
                                  [audits]="crewHotelLogs"
                                  [hasMore]="crewHotelLogsHasMore"
                                  (nextPage)="crewHotelLogsNextPage.emit(crew.arrivalHotelId)"
                                  noAuditsMessage="No audit records for hotel"
                                ></sd-portal-audit-detail-list-v2>
                              </ng-template>
                            </mat-expansion-panel>
                          </mat-accordion>

                          <!-- Transportation (Departure) -->
                          <mat-accordion *ngIf="crew.departureTransportationId">
                            <mat-expansion-panel
                              class="nested-panel"
                              (opened)="crewTransportationLogsOpened.emit(crew.departureTransportationId)"
                            >
                              <mat-expansion-panel-header>
                                <mat-panel-title>Transportation (Departure)</mat-panel-title>
                              </mat-expansion-panel-header>
                              <ng-template matExpansionPanelContent>
                                <sd-portal-audit-detail-list-v2
                                  [loading]="crewTransportationLogsLoading"
                                  [loaded]="crewTransportationLogsLoaded"
                                  [audits]="crewTransportationLogs"
                                  [hasMore]="crewTransportationLogsHasMore"
                                  (nextPage)="crewTransportationLogsNextPage.emit(crew.departureTransportationId)"
                                  noAuditsMessage="No audit records for transportation"
                                ></sd-portal-audit-detail-list-v2>
                              </ng-template>
                            </mat-expansion-panel>
                          </mat-accordion>

                          <!-- Transportation (Arrival) -->
                          <mat-accordion *ngIf="crew.arrivalTransportationId">
                            <mat-expansion-panel
                              class="nested-panel"
                              (opened)="crewTransportationLogsOpened.emit(crew.arrivalTransportationId)"
                            >
                              <mat-expansion-panel-header>
                                <mat-panel-title>Transportation (Arrival)</mat-panel-title>
                              </mat-expansion-panel-header>
                              <ng-template matExpansionPanelContent>
                                <sd-portal-audit-detail-list-v2
                                  [loading]="crewTransportationLogsLoading"
                                  [loaded]="crewTransportationLogsLoaded"
                                  [audits]="crewTransportationLogs"
                                  [hasMore]="crewTransportationLogsHasMore"
                                  (nextPage)="crewTransportationLogsNextPage.emit(crew.arrivalTransportationId)"
                                  noAuditsMessage="No audit records for transportation"
                                ></sd-portal-audit-detail-list-v2>
                              </ng-template>
                            </mat-expansion-panel>
                          </mat-accordion>
                        </ng-template>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <button
                      *ngIf="flightCrewMembersHasMore"
                      mat-button
                      color="primary"
                      (click)="flightCrewMembersNextPage.emit(leg.flightId)"
                    >
                      Load More
                    </button>
                  </div>
                </ng-template>
              </mat-expansion-panel>

              <!-- Passengers -->
              <mat-expansion-panel
                class="nested-panel"
                (opened)="flightPassengersOpened.emit(leg.flightId)"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>Passengers</mat-panel-title>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                  <div *ngIf="flightPassengersLoading">Loading...</div>
                  <div *ngIf="flightPassengersLoaded">
                    <div *ngIf="!flightPassengers || flightPassengers.length === 0">
                      No passengers found
                    </div>
                    <mat-accordion *ngIf="flightPassengers && flightPassengers.length > 0">
                      <mat-expansion-panel
                        *ngFor="let pax of flightPassengers"
                        class="nested-panel"
                        (opened)="passengerLogsOpened.emit(pax.paxId)"
                      >
                        <mat-expansion-panel-header>
                          <mat-panel-title>{{ pax.firstName }} {{ pax.lastName }}</mat-panel-title>
                        </mat-expansion-panel-header>
                        <ng-template matExpansionPanelContent>
                          <!-- Passenger logs -->
                          <sd-portal-audit-detail-list-v2
                            [loading]="passengerLogsLoading"
                            [loaded]="passengerLogsLoaded"
                            [audits]="passengerLogs"
                            [hasMore]="passengerLogsHasMore"
                            (nextPage)="passengerLogsNextPage.emit(pax.paxId)"
                            noAuditsMessage="No audit records for passenger"
                          ></sd-portal-audit-detail-list-v2>

                          <!-- Catering (Departure) -->
                          <mat-accordion *ngIf="pax.departureCateringId">
                            <mat-expansion-panel
                              class="nested-panel"
                              (opened)="passengerCateringLogsOpened.emit(pax.departureCateringId)"
                            >
                              <mat-expansion-panel-header>
                                <mat-panel-title>Catering (Departure)</mat-panel-title>
                              </mat-expansion-panel-header>
                              <ng-template matExpansionPanelContent>
                                <sd-portal-audit-detail-list-v2
                                  [loading]="passengerCateringLogsLoading"
                                  [loaded]="passengerCateringLogsLoaded"
                                  [audits]="passengerCateringLogs"
                                  [hasMore]="passengerCateringLogsHasMore"
                                  (nextPage)="passengerCateringLogsNextPage.emit(pax.departureCateringId)"
                                  noAuditsMessage="No audit records for catering"
                                ></sd-portal-audit-detail-list-v2>
                              </ng-template>
                            </mat-expansion-panel>
                          </mat-accordion>

                          <!-- Hotel (Departure) -->
                          <mat-accordion *ngIf="pax.departureHotelId">
                            <mat-expansion-panel
                              class="nested-panel"
                              (opened)="passengerHotelLogsOpened.emit(pax.departureHotelId)"
                            >
                              <mat-expansion-panel-header>
                                <mat-panel-title>Hotel (Departure)</mat-panel-title>
                              </mat-expansion-panel-header>
                              <ng-template matExpansionPanelContent>
                                <sd-portal-audit-detail-list-v2
                                  [loading]="passengerHotelLogsLoading"
                                  [loaded]="passengerHotelLogsLoaded"
                                  [audits]="passengerHotelLogs"
                                  [hasMore]="passengerHotelLogsHasMore"
                                  (nextPage)="passengerHotelLogsNextPage.emit(pax.departureHotelId)"
                                  noAuditsMessage="No audit records for hotel"
                                ></sd-portal-audit-detail-list-v2>
                              </ng-template>
                            </mat-expansion-panel>
                          </mat-accordion>

                          <!-- Hotel (Arrival) -->
                          <mat-accordion *ngIf="pax.arrivalHotelId">
                            <mat-expansion-panel
                              class="nested-panel"
                              (opened)="passengerHotelLogsOpened.emit(pax.arrivalHotelId)"
                            >
                              <mat-expansion-panel-header>
                                <mat-panel-title>Hotel (Arrival)</mat-panel-title>
                              </mat-expansion-panel-header>
                              <ng-template matExpansionPanelContent>
                                <sd-portal-audit-detail-list-v2
                                  [loading]="passengerHotelLogsLoading"
                                  [loaded]="passengerHotelLogsLoaded"
                                  [audits]="passengerHotelLogs"
                                  [hasMore]="passengerHotelLogsHasMore"
                                  (nextPage)="passengerHotelLogsNextPage.emit(pax.arrivalHotelId)"
                                  noAuditsMessage="No audit records for hotel"
                                ></sd-portal-audit-detail-list-v2>
                              </ng-template>
                            </mat-expansion-panel>
                          </mat-accordion>

                          <!-- Transportation (Departure) -->
                          <mat-accordion *ngIf="pax.departureTransportationId">
                            <mat-expansion-panel
                              class="nested-panel"
                              (opened)="passengerTransportationLogsOpened.emit(pax.departureTransportationId)"
                            >
                              <mat-expansion-panel-header>
                                <mat-panel-title>Transportation (Departure)</mat-panel-title>
                              </mat-expansion-panel-header>
                              <ng-template matExpansionPanelContent>
                                <sd-portal-audit-detail-list-v2
                                  [loading]="passengerTransportationLogsLoading"
                                  [loaded]="passengerTransportationLogsLoaded"
                                  [audits]="passengerTransportationLogs"
                                  [hasMore]="passengerTransportationLogsHasMore"
                                  (nextPage)="passengerTransportationLogsNextPage.emit(pax.departureTransportationId)"
                                  noAuditsMessage="No audit records for transportation"
                                ></sd-portal-audit-detail-list-v2>
                              </ng-template>
                            </mat-expansion-panel>
                          </mat-accordion>

                          <!-- Transportation (Arrival) -->
                          <mat-accordion *ngIf="pax.arrivalTransportationId">
                            <mat-expansion-panel
                              class="nested-panel"
                              (opened)="passengerTransportationLogsOpened.emit(pax.arrivalTransportationId)"
                            >
                              <mat-expansion-panel-header>
                                <mat-panel-title>Transportation (Arrival)</mat-panel-title>
                              </mat-expansion-panel-header>
                              <ng-template matExpansionPanelContent>
                                <sd-portal-audit-detail-list-v2
                                  [loading]="passengerTransportationLogsLoading"
                                  [loaded]="passengerTransportationLogsLoaded"
                                  [audits]="passengerTransportationLogs"
                                  [hasMore]="passengerTransportationLogsHasMore"
                                  (nextPage)="passengerTransportationLogsNextPage.emit(pax.arrivalTransportationId)"
                                  noAuditsMessage="No audit records for transportation"
                                ></sd-portal-audit-detail-list-v2>
                              </ng-template>
                            </mat-expansion-panel>
                          </mat-accordion>
                        </ng-template>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <button
                      *ngIf="flightPassengersHasMore"
                      mat-button
                      color="primary"
                      (click)="flightPassengersNextPage.emit(leg.flightId)"
                    >
                      Load More
                    </button>
                  </div>
                </ng-template>
              </mat-expansion-panel>

              <!-- Fuel -->
              <mat-expansion-panel
                *ngIf="leg.departureFuelId"
                class="nested-panel"
                (opened)="legFuelLogsOpened.emit(leg.departureFuelId)"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>Fuel</mat-panel-title>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                  <sd-portal-audit-detail-list-v2
                    [loading]="legFuelLogsLoading"
                    [loaded]="legFuelLogsLoaded"
                    [audits]="legFuelLogs"
                    [hasMore]="legFuelLogsHasMore"
                    (nextPage)="legFuelLogsNextPage.emit(leg.departureFuelId)"
                    noAuditsMessage="No audit records for fuel"
                  ></sd-portal-audit-detail-list-v2>
                </ng-template>
              </mat-expansion-panel>

              <!-- Requester / Approver / Planner -->
              <mat-expansion-panel
                class="nested-panel"
                (opened)="flightSchedulersOpened.emit(leg.flightId)"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>Requester / Approver / Planner</mat-panel-title>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                  <div *ngIf="flightSchedulersLoading">Loading...</div>
                  <div *ngIf="flightSchedulersLoaded">
                    <div *ngIf="!flightSchedulers || flightSchedulers.length === 0">
                      No schedulers found
                    </div>
                    <mat-accordion *ngIf="flightSchedulers && flightSchedulers.length > 0">
                      <mat-expansion-panel
                        *ngFor="let scheduler of flightSchedulers"
                        class="nested-panel"
                        (opened)="schedulerLogsOpened.emit(scheduler.schedulerId)"
                      >
                        <mat-expansion-panel-header>
                          <mat-panel-title>{{ scheduler.firstName }} {{ scheduler.lastName }}</mat-panel-title>
                        </mat-expansion-panel-header>
                        <ng-template matExpansionPanelContent>
                          <sd-portal-audit-detail-list-v2
                            [loading]="schedulerLogsLoading"
                            [loaded]="schedulerLogsLoaded"
                            [audits]="schedulerLogs"
                            [hasMore]="schedulerLogsHasMore"
                            (nextPage)="schedulerLogsNextPage.emit(scheduler.schedulerId)"
                            noAuditsMessage="No audit records for this scheduler"
                          ></sd-portal-audit-detail-list-v2>
                        </ng-template>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <button
                      *ngIf="flightSchedulersHasMore"
                      mat-button
                      color="primary"
                      (click)="flightSchedulersNextPage.emit(leg.flightId)"
                    >
                      Load More
                    </button>
                  </div>
                </ng-template>
              </mat-expansion-panel>

              <!-- Depart / Arrive Dates -->
              <mat-expansion-panel
                *ngIf="leg.eventId"
                class="nested-panel"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>Depart / Arrive Dates</mat-panel-title>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                  <sd-portal-audit-detail-list-v2
                    [loading]="legEventLogsLoading"
                    [loaded]="legEventLogsLoaded"
                    [audits]="legEventLogs"
                    [hasMore]="legEventLogsHasMore"
                    (nextPage)="legEventLogsNextPage.emit(leg.eventId)"
                    noAuditsMessage="No audit records for departure / arrival dates"
                  ></sd-portal-audit-detail-list-v2>
                </ng-template>
              </mat-expansion-panel>

              <!-- Leg Details -->
              <mat-expansion-panel
                class="nested-panel"
                (opened)="legFlightLogsOpened.emit(leg.flightId)"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>Leg Details</mat-panel-title>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                  <sd-portal-audit-detail-list-v2
                    [loading]="legFlightLogsLoading"
                    [loaded]="legFlightLogsLoaded"
                    [audits]="legFlightLogs"
                    [hasMore]="legFlightLogsHasMore"
                    (nextPage)="legFlightLogsNextPage.emit(leg.flightId)"
                    noAuditsMessage="No audit records for leg details"
                  ></sd-portal-audit-detail-list-v2>
                </ng-template>
              </mat-expansion-panel>
            </mat-accordion>

            <!-- TODO: Leg notes section (future iteration) -->
          </div>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>

    <button
      *ngIf="tripLegsHasMore"
      mat-button
      (click)="onTripLegsNextPage.emit(tripId)"
      style="margin-top: 16px;"
    >
      Load More Legs
    </button>
  </div>
  <ng-template #noTripLegs>
    <p>No legs found for this trip</p>
  </ng-template>
</div>
